import {
  getEnvironment,
  getRegionFromHost,
  Locale,
  getRegionFromLocale,
  getServerEnvironment,
} from '@raisin/cp-utils';
import { API_GATEWAY_ENDPOINTS } from './types';

const BASEURLS = {
  dbs: {
    DEU: {
      local: `${API_GATEWAY_ENDPOINTS.LOCAL}/dbs/v1`,
      development: `${API_GATEWAY_ENDPOINTS.DEU_DEVELOPMENT}/dbs/v1`,
      onboarding: `${API_GATEWAY_ENDPOINTS.DEU_ONBOARDING}/dbs/v1`,
      production: `${API_GATEWAY_ENDPOINTS.DEU_PRODUCTION}/dbs/v1`,
      staging: `${API_GATEWAY_ENDPOINTS.DEU_STAGING}/dbs/v1`,
    },
    GBR: {
      local: `${API_GATEWAY_ENDPOINTS.LOCAL}/dbs/v1`,
      development: `${API_GATEWAY_ENDPOINTS.GBR_DEVELOPMENT}/dbs/v1`,
      onboarding: `${API_GATEWAY_ENDPOINTS.GBR_ONBOARDING}/dbs/v1`,
      production: `${API_GATEWAY_ENDPOINTS.GBR_PRODUCTION}/dbs/v1`,
      staging: `${API_GATEWAY_ENDPOINTS.GBR_STAGING}/dbs/v1`,
    },
  },
  varify: {
    USA: {
      local: 'https://varify-us.dev-raisin.com',
      development: 'https://varify-us.dev-raisin.com',
      staging: 'https://varify-us.staging-raisin.com',
      onboarding: 'https://varify-us.onboarding-raisin.com',
      production: 'https://varify-us.raisin.com',
    },
  },
};

export const getMicroserviceBaseUrl = (microserviceName: string): string => {
  const environment = getEnvironment();
  const region = getRegionFromHost();
  return (
    BASEURLS?.[microserviceName]?.[region]?.[environment] ??
    `https://internal-api.weltsparen.de/${microserviceName}/api/v1`
  );
};

export const getMicroserviceBaseUrlServer = (microserviceName: string, locale: Locale) => {
  const environment = getServerEnvironment() ?? 'production';
  const region = getRegionFromLocale(locale);
  const base =
    BASEURLS?.[microserviceName]?.[region]?.[environment] ??
    `https://internal-api.weltsparen.de/${microserviceName}/api/v1`;
  return (path: string) => `${base}${path}`;
};
